import { PropsWithChildren } from 'react';
import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import MenuIcon from '@material-ui/icons/Menu';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarSpace,
} from '@backstage/core-components';
import { useMediaQuery, useTheme } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { rootTranslationRef } from '../../translations/features/root/root';
import { SidebarToggleButton } from './SidebarToggleButton';
import { SidebarMenuIcon } from './SidebarMenuIcon';
import { UserMenuDropdown } from './UserMenuDropdown';

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const { t } = useTranslationRef(rootTranslationRef);
  const theme = useTheme();

  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });

  return (
    <SidebarPage>
      <Sidebar>
        {!isMobileDevice && (
          <>
            <SidebarGroup label={t('sidebar.group.menu')} icon={<SidebarMenuIcon />}>
              <SidebarToggleButton />
            </SidebarGroup>
            <SidebarDivider />
          </>
        )}

        <SidebarGroup
          label={t('sidebar.group.search') as string}
          icon={<SearchIcon />}
          to="/search"
        >
          <SidebarSearchModal />
        </SidebarGroup>
        <SidebarDivider />

        <SidebarGroup
          label={t('sidebar.group.navigation')}
          icon={isMobileDevice ? <MenuIcon /> : <SidebarMenuIcon />}
        >
          <SidebarItem
            icon={HomeIcon}
            to="catalog"
            text={t('sidebar.link.home')}
          />
          <SidebarItem
            icon={ExtensionIcon}
            to="api-docs"
            text={t('sidebar.link.apis')}
          />
          <SidebarItem
            icon={LibraryBooks}
            to="docs"
            text={t('sidebar.link.docs')}
          />
          <SidebarItem
            icon={CreateComponentIcon}
            to="create"
            text={t('sidebar.link.create')}
          />
          <SidebarDivider />
        </SidebarGroup>

        <SidebarSpace />
        <SidebarDivider />

        <NotificationsSidebarItem />
        <SidebarDivider />

        <SidebarGroup
          label={t('sidebar.group.settings')}
          icon={isMobileDevice ? <UserSettingsSignInAvatar /> : undefined}
          to={isMobileDevice ? "/settings" : undefined}
        >
          {isMobileDevice ? (
            <SidebarSettings />
          ) : (
            <UserMenuDropdown />
          )}
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  );
};
